import { render, staticRenderFns } from "./OrdinanceCityRegistDialog.vue?vue&type=template&id=ec5da9f8&scoped=true&"
import script from "./OrdinanceCityRegistDialog.vue?vue&type=script&lang=js&"
export * from "./OrdinanceCityRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5da9f8",
  null
  
)

export default component.exports